export default function validateEmail(input) {
  const
    value = input.value,
    mailRegex = /^\S+@\S+\.\S+/,
    formGroup = input.closest('.form-group');

  if (value.trim() !== '' && mailRegex.test(value)) {
    formGroup.classList.remove('form-group--has-danger');
    formGroup.classList.add('form-group--has-success');
    return true;
  }

  formGroup.classList.remove('form-group--has-success');
  formGroup.classList.add('form-group--has-danger');
  return false;
}
